import { Node as ProseMirrorNode } from '@tiptap/pm/model'
import { NodeView } from '@tiptap/pm/view'

export function updateColumns(
  node: ProseMirrorNode,
  colgroup: Element,
  table: Element,
  cellMinWidth: number,
  overrideCol?: number,
  overrideValue?: any
) {
  let totalWidth = 0
  const defaultWidth = 200
  let nextDOM = colgroup.firstChild
  const row = node.firstChild

  if (!row) return

  for (let i = 0, col = 0; i < row.childCount; i += 1) {
    const { colspan, colwidth } = row.child(i).attrs
    // Create a safe copy of colwidth array
    const currentColwidth = colwidth ? [...colwidth] : []

    for (let j = 0; j < colspan; j += 1, col += 1) {
      let width = defaultWidth

      if (overrideCol === col) {
        width = overrideValue
      } else if (currentColwidth && currentColwidth[j]) {
        width = currentColwidth[j]
      }

      const cssWidth = `${width}px`
      totalWidth += width

      if (!nextDOM) {
        const colEl = document.createElement('col')
        colEl.style.width = cssWidth
        colgroup.appendChild(colEl)
      } else {
        // @ts-ignore
        if (nextDOM.style.width !== cssWidth) {
          // @ts-ignore
          nextDOM.style.width = cssWidth
        }
        nextDOM = nextDOM.nextSibling
      }
    }
  }

  while (nextDOM) {
    const after = nextDOM.nextSibling
    nextDOM.parentNode?.removeChild(nextDOM)
    nextDOM = after
  }

  // @ts-ignore
  table.style.width = `${totalWidth}px`
  // @ts-ignore
  table.style.tableLayout = 'fixed'
}

export class CustomTableView implements NodeView {
  node: ProseMirrorNode
  cellMinWidth: number
  dom: Element
  table: Element
  colgroup: Element
  // @ts-ignore
  contentDOM: Element

  constructor(node: ProseMirrorNode, cellMinWidth: number) {
    this.node = node
    this.cellMinWidth = cellMinWidth
    this.dom = document.createElement('div')
    this.dom.className = 'rt-table'

    this.table = this.dom.appendChild(document.createElement('table'))
    this.colgroup = this.table.appendChild(document.createElement('colgroup'))
    updateColumns(node, this.colgroup, this.table, cellMinWidth)
    this.contentDOM = this.table.appendChild(document.createElement('tbody'))
  }

  update(node: ProseMirrorNode) {
    if (node.type !== this.node.type) return false
    this.node = node
    updateColumns(node, this.colgroup, this.table, this.cellMinWidth)
    return true
  }

  ignoreMutation(mutation: any) {
    return (
      mutation.type === 'attributes' &&
      (mutation.target === this.table ||
        this.colgroup.contains(mutation.target))
    )
  }
}
